var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"site-content"},[_c('el-card',{staticClass:"el-card-set-width",class:[
      _vm.url.indexOf('home') != -1 && _vm.customHome ? 'bg' : '',
      _vm.$route.name == 'queue' || _vm.$route.name == 'case-details'
        ? 'noPaddTop'
        : '',
    ],attrs:{"body-style":_vm.siteContentViewHeight}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }